// src/lib/reportRenderer.js
function boldify(s = "") {
  return String(s).replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
}

/** --- / *** / ___ 같은 마크다운 구분선 라인인지 체크 (렌더링에서 제외) */
function isHrLine(line = "") {
  const t = String(line).trim();
  return /^(-{3,}|\*{3,}|_{3,})$/.test(t);
}

/**
 * Markdown 유사 텍스트를 "섹션 단위(div.profiling-block)"로 감싼 HTML로 변환
 * - ### : 섹션 타이틀(h3.report-title)
 * - #### : 서브타이틀(h4.report-subtitle)
 * - -    : 불릿(ul.report-list > li)
 * - 그 외 : 본문(p.report-paragraph)
 * - iconHTML: 첫 섹션 타이틀 앞에 아이콘 주입(선택)
 */
export function buildReportHtml(text = "", { iconHTML } = {}) {
  const lines = String(text).trim().split(/\r?\n/);

  let html = "";
  let sectionOpen = false;
  let inList = false;
  let injectedIcon = false;

  const closeList = () => {
    if (inList) {
      html += "</ul>";
      inList = false;
    }
  };

  const closeSection = () => {
    closeList();
    if (sectionOpen) {
      html += "</div>"; // .profiling-block
      sectionOpen = false;
    }
  };

  const openSection = () => {
    if (!sectionOpen) {
      html += `<div class="profiling-block">`;
      sectionOpen = true;
    }
  };

  // 본문 라인 파싱
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) continue;

    // ✅ AI 응답에 포함된 '---' 같은 구분선은 표시하지 않음
    if (isHrLine(line)) {
      closeList(); // 리스트 중간에 들어오면 리스트만 닫고 무시
      continue;
    }

    // 섹션 타이틀
    if (line.startsWith("### ")) {
      // 이전 섹션 닫고 섹션 구분선 삽입
      if (sectionOpen) {
        closeSection();
        html += `<hr class="report-hr">`;
      }
      openSection();
      const titleHtml = boldify(line.slice(4));
      const icon = !injectedIcon && iconHTML ? `${iconHTML} ` : "";
      injectedIcon = injectedIcon || !!iconHTML;
      html += `<h3 class="report-title">${icon}${titleHtml}</h3>`;
      continue;
    }

    // 서브타이틀
    if (line.startsWith("#### ")) {
      openSection();
      closeList();
      html += `<h4 class="report-subtitle">${boldify(line.slice(5))}</h4>`;
      continue;
    }

    // 불릿
    if (line.startsWith("- ")) {
      openSection();
      if (!inList) {
        html += `<ul class="report-list">`;
        inList = true;
      }
      html += `<li>${boldify(line.slice(2))}</li>`;
      continue;
    }

    // 일반 문단
    openSection();
    closeList();
    html += `<p class="report-paragraph">${boldify(line)}</p>`;
  }

  // 마무리
  closeSection();
  return html;
}
